import { render, staticRenderFns } from "./carousel.vue?vue&type=template&id=c4ed0462&"
import script from "./carousel.vue?vue&type=script&lang=js&"
export * from "./carousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangbin/workspace/project/bin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c4ed0462')) {
      api.createRecord('c4ed0462', component.options)
    } else {
      api.reload('c4ed0462', component.options)
    }
    module.hot.accept("./carousel.vue?vue&type=template&id=c4ed0462&", function () {
      api.rerender('c4ed0462', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/carousel/carousel.vue"
export default component.exports